import React from 'react';
import { Radio } from 'antd';
import { F90M } from '../../../services/pw9208Api';

interface Tab2Props {
  formData: Partial<F90M>;
  isEditing: boolean;
  getField: <K extends keyof F90M>(key: K) => F90M[K];
  setField: (key: keyof F90M, value: unknown) => void;
}

// Map Y/N/empty → Radio value 1/2/3
const approvalToRadio = (v: string): number => {
  if (v === 'Y') return 1;
  if (v === 'N') return 2;
  return 3;
};
const radioToApproval = (n: number): string => {
  if (n === 1) return 'Y';
  if (n === 2) return 'N';
  return '';
};

const dateStr = (v: string | null | undefined): string => {
  if (!v) return '';
  return typeof v === 'string' ? v.replace('T', ' ').slice(0, 10) : '';
};

const ApprovalSection: React.FC<{
  label: string;
  statusField: keyof F90M;
  approverField: keyof F90M;
  dateField: keyof F90M;
  noteField: keyof F90M;
  isEditing: boolean;
  getField: <K extends keyof F90M>(key: K) => F90M[K];
  setField: (key: keyof F90M, value: unknown) => void;
}> = ({ label, statusField, approverField, dateField, noteField, isEditing, getField, setField }) => (
  <div className="approval-section">
    <div className="approval-header">
      <strong>{label}</strong>
    </div>
    <div className="form-grid">
      <label>核准狀態</label>
      <Radio.Group
        value={approvalToRadio((getField(statusField) as string) || '')}
        disabled={!isEditing}
        onChange={e => setField(statusField, radioToApproval(e.target.value))}
      >
        <Radio value={1}>Y（同意）</Radio>
        <Radio value={2}>N（不同意）</Radio>
        <Radio value={3}>（未決）</Radio>
      </Radio.Group>
    </div>
    <div className="form-grid">
      <label>核准人代號</label>
      <input
        value={(getField(approverField) as string) || ''}
        disabled={!isEditing}
        maxLength={8}
        onChange={e => setField(approverField, e.target.value)}
      />
      <label>核准日期</label>
      <input
        type="date"
        value={dateStr(getField(dateField) as string | null)}
        disabled={!isEditing}
        onChange={e => setField(dateField, e.target.value || null)}
      />
    </div>
    <div className="form-row">
      <label>核准說明</label>
      <textarea
        rows={2}
        value={(getField(noteField) as string) || ''}
        disabled={!isEditing}
        onChange={e => setField(noteField, e.target.value)}
        className="form-textarea"
      />
    </div>
  </div>
);

const Tab2Approval: React.FC<Tab2Props> = React.memo(({ isEditing, getField, setField }) => (
  <div className="pw9208-tab2">
    <ApprovalSection
      label="單位主管核准"
      statusField="f90m_61"
      approverField="f90m_62"
      dateField="f90m_63"
      noteField="f90m_64"
      isEditing={isEditing}
      getField={getField}
      setField={setField}
    />
    <ApprovalSection
      label="人事主管核准"
      statusField="f90m_66"
      approverField="f90m_67"
      dateField="f90m_68"
      noteField="f90m_69"
      isEditing={isEditing}
      getField={getField}
      setField={setField}
    />
    <ApprovalSection
      label="副總核准"
      statusField="f90m_71"
      approverField="f90m_72"
      dateField="f90m_73"
      noteField="f90m_74"
      isEditing={isEditing}
      getField={getField}
      setField={setField}
    />
    <ApprovalSection
      label="總經理核准"
      statusField="f90m_76"
      approverField="f90m_77"
      dateField="f90m_78"
      noteField="f90m_79"
      isEditing={isEditing}
      getField={getField}
      setField={setField}
    />
  </div>
));

Tab2Approval.displayName = 'Tab2Approval';
export default Tab2Approval;
